import { Types } from "../actions/actionTypes";

const initialState = {
    deviceVitalData: {}
}

// action.payload = {
//     "bedId": "b-1234",
//     "dongleId": "d-35678",
//     "deviceType": "Monitor",
//     "deviceId": "m-1234",
//     "vitals": [{
//         "name": "spo2",
//         "id": "1234",
//         "unit": "b/min",
//         "data": [{
//             "value": "90",
//             "time": "7594684345234254"
//         }, {
//             "value": "92",
//             "time": "7594684345234254"
//         }]
//     }, {
//         "name": "temp",
//         "id": "1234",
//         "unit": "b/min",
//         "data": [{
//             "value": "90",
//             "time": "7594684345234254"
//         }, {
//             "value": "92",
//             "time": "7594684345234254"
//         }]
//     }],
// }

// let stateData = {
//     "bed1": {
//         "Monitor": {
//             "id": "1234",
//             "vitals": [{

//             }]
//         },
//         "Ventilator": {
//             ...data
//         }
//     },
//     "bed2": {
//         "monitor": {

//         },
//     }
// }

export const deviceVitalDataReducer = (state = initialState, action) => {

    switch (action.type) {
        case Types.DEVICE_VITAL_DATA: {

            let bedId = action.payload.bedId;
            let patientMonitorId = action.payload.deviceId;
            let dongleId = action.payload.dongleId;
            let deviceType = action.payload.deviceType && action.payload.deviceType.toUpperCase();
            let vitals = action.payload.vitals;

            // if (!bedId || !patientMonitorId) return;
            let deviceVitalData = state.deviceVitalData;

            deviceVitalData[bedId] = {
                ...deviceVitalData[bedId],
                dongleId: dongleId,
                bedId: bedId,
                [deviceType]: {
                    patientMonitorId: patientMonitorId,
                    deviceType: deviceType,
                    vitals: vitals
                }
            }

            return {
                ...state,
                deviceVitalData: { ...deviceVitalData }
            }
        }
        default:
            return state;
    }
}

